import PropTypes from "prop-types"
import { FeatureAction, FeatureKey, FeaturePermission } from "../api/generated"

export const featureActionPropType = PropTypes.oneOf([
  FeatureAction.View,
  FeatureAction.UpdateVisibility,
  FeatureAction.AuthLogin
])

export const featureKeyPropType = PropTypes.oneOf([
  FeatureKey.CohortMemberDirectory,
  FeatureKey.CohortActivityFeed,
  FeatureKey.AuthPlatform,
  FeatureKey.AuthLoginOptionPassword,
  FeatureKey.AuthLoginOptionEmailLink,
  FeatureKey.AuthLoginOptionGlobalSsoGoogle,
  FeatureKey.AuthLoginOptionGlobalSsoApple
])

export const featureContextPropType = PropTypes.shape({
  resource_id: PropTypes.number,
  cohort_id: PropTypes.number
})

export const permissionInContextPropType = PropTypes.oneOf([
  FeaturePermission.AdminOnly,
  FeaturePermission.StaffOnly,
  FeaturePermission.Everyone
])

export const featurePropType = {
  feature_action: featureActionPropType.isRequired,
  feature_key: featureKeyPropType.isRequired,
  permission_in_context: permissionInContextPropType.isRequired
  // resource_id: resourceId,
  // cohort_id: cohortId,
}

export const featurePermissionsQueryPropTypes = {
  featureAction: featureActionPropType,
  featureKeys: PropTypes.arrayOf(featureKeyPropType),
  context: featureContextPropType
}
